import React from 'react';

const stored = {
  whiteList: JSON.parse(
    localStorage.getItem('whiteList') || sessionStorage.getItem('whiteList') || '[]'
  ),
  userType: localStorage.getItem('userType') || sessionStorage.getItem('userType') || '',
  // Only App's provider ever sets this false, and only while a signed-in user's real
  // permissions are in flight.
  ready: true,
};

export const PermissionsContext = React.createContext(stored);
